<template>
  <div class="provider-row">
    <dropdown
      class="identity-provider"
      :options="providerOptions"
      :value="idProvider.identityProvider"
      :onChange="val => change({ ...idProvider, identityProvider: val })"
      placeholder="IDENTITY PROVIDER"
    />
    <div class="d-flex align-items-center">
      <input
        type="text"
        :value="idProvider.key"
        @change="event => change({ ...idProvider, key: event.target.value })"
      />
      <a @click="$emit('delete')"><i class="material-icons">cancel</i></a>
    </div>
  </div>
</template>

<script>
import Dropdown from './Dropdown';
export default {
  components: { Dropdown },
  props: ['idProvider'],
  computed: {
    providerOptions() {
      return [{ text: 'Azure AD', value: 'AzureAD' }];
    },
  },
  methods: {
    change(newVal) {
      this.$emit('change', newVal);
    },
  },
};
</script>
<!--TODO - Add Scoped-->
<style lang="scss" scoped>
@import '../styles/colors.scss';
.provider-row {
  display: flex !important;
  flex-direction: row;
  margin: 10px auto;
  align-items: flex-end;

  .identity-provider {
    padding-right: 10px;
  }

  input {
    height: 40px;
    flex: 1;
    padding: 5px 12px;
    margin-right: 8px;
    font-size: 14px;
  }

  i {
    vertical-align: middle;
    top: -1px;
    position: relative;
    font-size: 20px;
    padding: 3px;
    opacity: 0.3;
    color: $sidebar-color;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }

  // span {
  //   position: relative;
  //   pointer-events: none;
  //   color: #929da9;
  //   margin: 0;
  //   width: 100%;
  //   text-transform: uppercase;
  //   font-size: 10px;
  //   font-weight: 500;
  //   display: block;
  // }
}
</style>
